import { render, staticRenderFns } from "./filter-word.vue?vue&type=template&id=6d5ebcae&scoped=true&"
import script from "./filter-word.vue?vue&type=script&lang=js&"
export * from "./filter-word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ebcae",
  null
  
)

export default component.exports